<template>
  <div class="page-header-wrapper">
    <div class="page-header page-header-default">
      <slot></slot>
    </div>
    <div class="mat"></div>
  </div>
  
</template>

<script>
  export default {
    props: {
      crumbs: {
        type: Object
      }
    }
  }
</script>

<style lang="scss" type="text/scss">
  @media screen and (max-width: 768px) {
    .page-header{
      height: 44px;
      line-height: 44px;
      padding: 0 20px;
      font-size: 14px;
    }
  }
  @media screen and (min-width: 769px) {
    .page-header-wrapper{
      width: 100%;
      height: 44px;
      margin-bottom: 20px;
      background-color: #fff;
      .page-header{
        float: left;
        height: 44px;
        line-height: 44px;
        width: 100%;
        padding: 0 20px;
        font-size: 14px;
        z-index: 100;
        .mat{
          height: 48px;
        }
        i{
          margin-right: 4px;
        }
      }
    }
  }



</style>



// WEBPACK FOOTER //
// crumbs.vue?4a4eb2b2